import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Properties } from '../../models/polymer/Properties.model'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api';
import config from '../../config';


interface QueryParams {
  uinfin: string
  singpass_token: string
}

export const hdbPropertyApi = createApi({
  reducerPath: 'hdbPropertyApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER, 
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
    headers.set("x-api-key", `${config.xApiKey}`);
  }}),
  endpoints: (builder) => ({
    getHDBPropertyByNric: builder.query<Properties[], QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${SUB_PATH_BASIC}/residential/list`,
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: Properties[], meta, arg)=>{
        return response;
      }
    }),
  }),
})

export const { useGetHDBPropertyByNricQuery } = hdbPropertyApi


/**THIS IS CHECK ADDITIONAL ROLE */
// const data:any[] = [
//   {
//       "owners": [
//           {
//               "uinfin": "ck05ibMOaAzGR7bODp4EL6umcvfZM9NohUD0lSbaUJs=",
//               "name": "Nikita Adnan von Joyce",
//               "dob": "1965-06-16",
//               "dod": "",
//               "residential_status": "C",
//               "marital_status": "M",
//               "live_status": "A",
//               "role_name": "Lessee"
//           },
//           {
//               "uinfin": "W8kMsoty0nXIKRKPnMZzGVV/Lg66uBDtLdzHv6IbhKk=",
//               "name": "Maverick Leigh of Melvin",
//               "dob": "1968-06-23",
//               "dod": "",
//               "residential_status": "C",
//               "marital_status": "D",
//               "live_status": "A",
//               "role_name": "Lessee"
//           }
//       ],
//       "occupiers": [],
//       "address": "BLK 21, GHIM MOH RD, #17-191, Singapore 270021",
//       "additional_roles": [],
//       "hdb_ref": "91341357911"
//   },
//   {
//       "owners": [],
//       "occupiers": [],
//       "address": "Block 103B, Bidadari Pk Dr, #16-41, Singapore 342103",
//       "additional_roles": [
//           {
//               "uinfin": "W8kMsoty0nXIKRKPnMZzGVV/Lg66uBDtLdzHv6IbhKk=",
//               "name": "Exactly 70",
//               "dob": "1978-01-01",
//               "dod": "0001-01-01",
//               "residential_status": "C",
//               "marital_status": "D",
//               "live_status": "A",
//               "role_name": "Executor"
//           }
//       ],
//       "hdb_ref": "91341357910"
//   }
// ]